module.exports = __webpack_public_path__ + "img/stripe-background@2x.4fc2438d.png";